import React, {useState} from 'react'
import { withAppContextDecorators } from '@/common/AppContext';
import {Breadcrumb, Input,Modal } from 'antd';
import { Toast } from 'antd-mobile'
import './index.less'
import api from "@/services/api";
import commonSetting from "@/config/commonSetting";
import {useHistory} from "react-router-dom";

const Assistant = (props) => {
    const history = useHistory()
    const [kfInfo,setKfInfo] = useState()
    const [message, setMessage] = useState(false)
    const [messageA, setMessageA] = useState(false)
    const getSearch = async (key)=>{
        const isInteger = /^[0-9]+$/
        if( !isInteger.test(key)){
            setMessageA(true)
            setTimeout(() => {
                setMessageA(false)
            },3000)
            return
        }
        if(!key.trim() || (key.trim().length<=0 )){
            setMessageA(true)
            setTimeout(() => {
                setMessageA(false)
            },3000)
            return
        }

        let resp = await api.pubController.publicFindGwServerInfoUsingGET({
            companyType:45,
            serverId: key,
        })
        if(resp.code == 0){
            if(resp.data != null){
                setKfInfo(resp.data)
            } else {
                setKfInfo(false)

                setMessage(true)
                setTimeout(() => {
                    setMessage(false)
                },3000)

            }
        } else {
            setMessage(true)
            setTimeout(() => {
                setMessage(false)
            },3000)

        }
    }

    return <div id="assistant">
        <div className={'breadcrumb-con warp'}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={()=>{history.push({pathname:'/index'})}}>首页</Breadcrumb.Item>
                <Breadcrumb.Item onClick={()=>{history.push({pathname:'/compliance'})}}>安全合规</Breadcrumb.Item>
                <Breadcrumb.Item>投研助理</Breadcrumb.Item>
            </Breadcrumb>
        </div>
        <div className={'centerBox warp box-h'}>
            <div className={'module-title'}>
                <h2>预防金融诈骗，保障资金安全</h2>
                <p>查询您所属助理是否为深圳市国诚投资咨询有限公司</p>
            </div>

            <div className={'searchBox'}>
                <Input.Search
                    enterButton="查询"
                    placeholder="请输入工号"
                    size="large"
                    onSearch={(key) => {
                        getSearch(key)
                    }}
                ></Input.Search>
            </div>

            {
                kfInfo &&
                <div className={'cardBox'}>
                    {
                        kfInfo.avatarUrl ?
                            <img className={'cardBox-img'} src={ commonSetting.OSS_URL + kfInfo.avatarUrl } />
                        :
                            <img className={'cardBox-img'} src={require('@/assets/images/compliance/people.png')} />
                    }

                    <div className={'cardBox-con'}>
                        <div className={'cardBox-title'}>
                            <h3>投研助理</h3>
                            <div className={'cardBox-name'}>{kfInfo.realName}</div>
                            <div className={'cardBox-line'}></div>
                        </div>

                        {
                            kfInfo.certificateNo !== '' && kfInfo.profile !== '' ?
                                <>
                                    <span>客服工号</span>
                                    <p>{kfInfo.id}</p>
                                </>
                                :
                                <>
                                    <span style={{paddingTop:'40px'}}>客服工号</span>
                                    <p style={{marginBottom:'32px'}}>{kfInfo.id}</p>
                                </>
                        }
                        {
                            kfInfo.certificateNo !== '' && kfInfo.certificateNo !== null ?
                            <>
                                <span>证券编号</span>
                                <p>{kfInfo.certificateNo}</p>
                            </> :
                                <></>
                        }
                        {
                            kfInfo.profile !== '' && kfInfo.profile !== null  ?
                                <>
                                    <span>服务理念</span>
                                    <p>{kfInfo.profile}</p>
                                </>:
                                <></>
                        }

                    </div>
                </div>
            }
        </div>

        <div className="msgText" style={{'display': message ? 'block' : 'none'}}>很抱歉，您所查找的客服不存在，请确认工号后再次查询！</div>
        <div className="msgText" style={{'display': messageA ? 'block' : 'none'}}>请输入准确的工号</div>


    </div>
}
export default withAppContextDecorators(Assistant)